export interface ClientListItem {
  accountType: string;
  clientCountry: string;
  clientLogin: number;
  clientName: string;
  closedPositions: number;
  currency: string;
  deposits: string;
  lastTradeDate: Date;
  leverage: number;
  netDeposits: string;
  partnershipEndDate?: Date;
  partnershipCode: string;
  partnershipStartDate: Date;
  phone: string;
  realEquity: string;
  volume: string;
  volumeLots: string;
  withDrawals: string;
  netInternalTransfersIn: string;
  netInternalTransfersOut: string;
}

export interface AssignmentData {
  clientName: string;
  partnershipCode: string;
  partnerName: string;
  isDirectClient: boolean;
}

export interface ClientAssignmentCheckModel {
  assignmentData: AssignmentData;
  isAssigned: boolean;
  supportEmail: string;
  partnershipCode: string;
}

export const reportEnColumns = [
  'partnership',
  'client name',
  'country',
  'currency',
  'account type',
  'start date',
  'login',
  'end date',
  'last trade date',
  'leverage',
  'volume',
  'volume lots',
  'closed positions',
  'deposits',
  'withdrawals',
  'net deposits',
  'real equity',
];
export interface ClientListEmailReportRequest {
  partnersClientsFilters: {
    currencies: string[];
    partnershipIds: number[];
  };
  reportEmailRequest: {
    email: null | string;
    includeTotal: boolean;
    tableColumns: string[];
    translatedTableColumns: string[];
    startDate: string | null;
    endDate: string | null;
  };
  showInactive: boolean;
}
